export interface GeneralNormConfig {
  isControlledPartyVisible: boolean;
  isContractNumberVisible: boolean;
  isWorkTypeVisible: boolean;
  isCommentVisible: boolean;
  isInspectionResultVisible: boolean;
}

export const EMPTY_GENERAL_NORM_CONFIG: GeneralNormConfig = {
  isControlledPartyVisible: false,
  isContractNumberVisible: false,
  isWorkTypeVisible: false,
  isCommentVisible: false,
  isInspectionResultVisible: false,
};

export const LEGACY_GENERAL_NORM_CONFIG: GeneralNormConfig = {
  isControlledPartyVisible: true,
  isContractNumberVisible: true,
  isWorkTypeVisible: true,
  isCommentVisible: true,
  isInspectionResultVisible: true,
};

export function normalizeGeneralNormConfig(
  config: Partial<GeneralNormConfig> | undefined,
  fallback: GeneralNormConfig = LEGACY_GENERAL_NORM_CONFIG
): GeneralNormConfig {
  if (!config) {
    return { ...fallback };
  }

  return {
    isControlledPartyVisible:
      config.isControlledPartyVisible ?? fallback.isControlledPartyVisible,
    isContractNumberVisible:
      config.isContractNumberVisible ?? fallback.isContractNumberVisible,
    isWorkTypeVisible:
      config.isWorkTypeVisible ?? fallback.isWorkTypeVisible,
    isCommentVisible:
      config.isCommentVisible ?? fallback.isCommentVisible,
    isInspectionResultVisible:
      config.isInspectionResultVisible ?? fallback.isInspectionResultVisible,
  };
}
